import { component, factory } from 'tsdi';
@component
export class WindowFactory {
    @factory({ name: 'Window' })
    public getWindow(): Window {
        return window;
    }
}
